import template from './truck.html';
import controller from './truck.controller';
import './truck.scss';

let truckComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL:'='
  },
  template,
  controller
};

export default truckComponent;


// WEBPACK FOOTER //
// ./client/app/components/truck/truck.component.js